// extracted by mini-css-extract-plugin
export default {"content":"Cpf_content__OKaST","inputContainer":"Cpf_inputContainer__wR7fL"};